import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientCategoryEntity } from './client-category.entity';
import { ItemCategoryEntity } from './item-category.entity';
import { PriceContractCategoryClientEntity } from './price-contract-category-client.entity';
import { PriceContractCategoryItemEntity } from './price-contract-category-item.entity';

@Index('category_externalId_uindex', ['deletedUserId', 'externalId'], {
	unique: true,
})
@Entity('category')
export class CategoryEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@OneToMany(
		() => ClientCategoryEntity,
		(clientCategory) => clientCategory.fkCategory,
	)
	public clientCategories!: Array<ClientCategoryEntity>;

	@OneToMany(() => ItemCategoryEntity, (itemCategory) => itemCategory.category)
	public itemCategories!: Array<ItemCategoryEntity>;

	@OneToMany(
		() => PriceContractCategoryClientEntity,
		(priceContractCategoryClient) => priceContractCategoryClient.category,
	)
	public priceContractCategoryClients!: Array<PriceContractCategoryClientEntity>;

	@OneToMany(
		() => PriceContractCategoryItemEntity,
		(priceContractCategoryItem) => priceContractCategoryItem.category,
	)
	public priceContractCategoryItems!: Array<PriceContractCategoryItemEntity>;
}
